import axios from 'axios'
import https from 'https'
export default () => {
  
  return axios.create({
    baseURL: 'https://api.safeotp.co.kr/otp',
    withCredentials: true,
    timeout: 10000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      "Access-Control-Allow-Origin": "*"
    },
    httpsAgent: new https.Agent({  
      rejectUnauthorized: false
    })
  })
}
